import SearchTracking from './search-tracking';

$(() => {
  new SearchTracking()

  // @ts-ignore
  s.ActivityMap.regionIDAttribute = "class";
})